import { memoize as memoize$1 } from '@shopify/function-enhancers';

function memoize(resolver) {
  return function (_target, propertyKey, descriptor) {
    const {
      value: method
    } = descriptor;

    if (!method || !(method instanceof Function)) {
      return descriptor;
    }

    return {
      get: function get() {
        const newDescriptor = {
          configurable: true,
          value: memoize$1(method, resolver)
        };
        Object.defineProperty(this, propertyKey, newDescriptor);
        return newDescriptor.value;
      }
    };
  };
}

export default memoize;
